import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'checkValueEmpty'
})
export class CheckValueEmptyPipe implements PipeTransform {
  constructor() {
  }

  transform(value: any): string {
    return (value != null && value != '') ? value : '-';
  }
}
